export default __webpack_public_path__ + "static/1-new-site-c0a36832f72c5b31668ad7ffaf8eee49.png";